import axios, { type AxiosResponse } from 'axios';

import Log from '@/Logger';
import { getAccessToken } from '@/auth';

function getEwbReqId(resp: any) {
    return resp?.headers?.['ricoh-ewb-request-id'] ?? '-';
}

const GRAPHQL_API_URL = import.meta.env.VITE_GRAPHQL_API_URL ?? '';

type Input = {
    [key: string]: Input | string | number | boolean;
};

type GraphQLBody = any;

export async function apiCall<T>(method: string, inputType: string, input: Input, output: string[]): Promise<AxiosResponse<T, GraphQLBody>> {
    const logger = Log.getLogger();

    logger.api.info('Cognito', 'Start to request: currentSession');
    const token = await getAccessToken();
    logger.api.info('Cognito', 'Succeed to request: currentSession');

    const apiResponse: AxiosResponse<T, GraphQLBody> = await axios.post<T>(
        GRAPHQL_API_URL,
        {
            query: `mutation($input:${inputType}!) { ${method}(input:$input) { ${output.join(', ')} }}`,
            variables: `{ "input": ${JSON.stringify(input)} }`,
        },
        {
            headers: {
                'Content-Type': 'application/graphql',
                Authorization: 'Bearer ' + token,
            },
        }
    );

    return apiResponse;
}

// ゴミ箱からドキュメントを復元するAPIを呼び出し
export async function restoreDocument(serialId: string, documentName: string): Promise<{ serialId: string; documentName: string }> {
    const logger = Log.getLogger();
    logger.api.info('Lantana-API', 'Start to request: restoreDocument');
    const resp = await apiCall<{ id: string; errors: any }>('restoreDocument', 'RestoreDocumentInput', { serialId, documentName }, ['documentName']);
    if (resp.data.errors && resp.data.errors.length && resp.data.errors.length > 0) {
        const reqid = getEwbReqId(resp);
        const msg = `Failed to execute restoreDocument API: id=${reqid}`;
        throw { serialId, documentName, err: new Error(msg) };
    }
    logger.api.info('Lantana-API', 'Succeed to request: restoreDocument', resp.headers);
    return { serialId, documentName };
}

// DDLバケットからDULバケットにドキュメントをコピーするAPIを呼び出し
export async function sendDocument(serialId: string, documentName: string): Promise<{ serialId: string; documentName: string }> {
    const logger = Log.getLogger();
    logger.api.info('Lantana-API', 'Start to request: sendDocument');
    const resp = await apiCall<{ id: string; errors: any }>('sendDocument', 'SendDocumentInput', { serialId, documentName }, ['documentName']);
    if (resp.data.errors && resp.data.errors.length && resp.data.errors.length > 0) {
        const reqid = getEwbReqId(resp);
        const msg = `Failed to execute sendDocument API: id=${reqid}`;
        logger.api.error('Lantana-API', msg, resp.headers);
        throw { serialId, documentName, err: new Error(msg) };
    }
    logger.api.info('Lantana-API', 'Succeed to request: sendDocument');
    return { serialId, documentName };
}

// ゴミ箱から完全に削除するAPIを呼び出し
export async function permanentlyDeleteDocument(serialId: string, documentName: string): Promise<{ serialId: string; documentName: string }> {
    const logger = Log.getLogger();
    logger.api.info('Lantana-API', 'Start to request: permanentlyDeleteDocument');
    const resp = await apiCall<{ id: string; errors: any }>('permanentlyDeleteDocument', 'PermanentlyDeleteDocumentInput', { serialId, documentName }, ['documentName']);
    if (resp.data.errors && resp.data.errors.length && resp.data.errors.length > 0) {
        const reqid = getEwbReqId(resp);
        const msg = `Failed to execute permanentlyDeleteDocument API: id=${reqid}`;
        logger.api.error('Lantana-API', msg, resp.headers);
        throw { serialId, documentName, err: new Error(msg) };
    }
    logger.api.info('Lantana-API', 'Succeed to request: permanentlyDeleteDocument');
    return { serialId, documentName };
}
